import { FINAL_CTA } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { GhostButton, PrimaryButton } from "@/components/site/Buttons";
import { scrollToSection } from "@/lib/scroll";

export const FinalCta = () => (
  <section
    data-testid="final-cta-section"
    className="relative isolate overflow-hidden py-28 lg:py-40"
  >
    <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(85%_70%_at_50%_0%,hsl(var(--navy-800)/0.85),transparent_70%)]" />

    <div className="shell text-center">
      <Reveal>
        <h2 className="display mx-auto max-w-4xl text-[2.4rem] leading-[0.95] text-offwhite sm:text-6xl lg:text-[4.5rem]">
          {FINAL_CTA.headline}
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-mist sm:text-base">
          {FINAL_CTA.paragraph}
        </p>
      </Reveal>
      <Reveal delay={0.22}>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <PrimaryButton
            data-testid="final-cta-get-in-touch"
            onClick={() => scrollToSection("contact")}
          >
            Get in touch
          </PrimaryButton>
          <GhostButton
            data-testid="final-cta-explore-businesses"
            onClick={() => scrollToSection("businesses")}
          >
            Explore our businesses
          </GhostButton>
        </div>
      </Reveal>
    </div>
  </section>
);
